import canvasManager from "slotworks/graphics/canvas/canvas-manager";
import AutoSmartUIGroup from "slotworks/smart-ui/auto-smart-ui-group";
import smartUiFlags, { SmartUIFlag } from "slotworks/smart-ui/smart-ui-flags";
import smartUiManager from "slotworks/smart-ui/smart-ui-manager";

export default class SmartUIDebugger {

    private flagElement: HTMLDivElement;
    private groupElement: HTMLDivElement;
    private checkboxes: SmartFlagCheckbox[] = [];

    public start() {
        this.draw();
        this.populateFlagToggles();
        this.updateGroups();
        this.updateCheckboxes();

        smartUiFlags.onFlagsUpdated.add(() => {
            this.updateCheckboxes();
            this.updateGroups();
        });
    }

    public toggle() {
        if (!this.flagElement || !this.groupElement) {
            this.start();
        } else {
            if (this.flagElement.parentElement) {
                canvasManager.rootNode.removeChild(this.flagElement);
            } else {
                canvasManager.rootNode.appendChild(this.flagElement);
            }

            if (this.groupElement.parentElement) {
                canvasManager.rootNode.removeChild(this.groupElement);
            } else {
                canvasManager.rootNode.appendChild(this.groupElement);
            }
        }
    }

    private draw() {
        this.flagElement = document.createElement("div");
        this.flagElement.id = "SmartUIDebugger-flags";

        this.flagElement.style.position = "fixed";
        this.flagElement.style.top = this.flagElement.style.right = "0";
        this.flagElement.style.zIndex = "900";
        this.flagElement.style.width = "15vw";
        this.flagElement.style.paddingTop = "3vh";
        this.flagElement.style.paddingLeft = "3vw";
        this.flagElement.style.pointerEvents = "all";

        this.flagElement.style.backgroundColor = "rgba(50,50,50,.5)";
        this.flagElement.style.border = "solid 1px white";

        this.flagElement.style.color = "#fff";
        this.flagElement.style.fontSize = "16px";

        canvasManager.rootNode.appendChild(this.flagElement);

        this.groupElement = document.createElement("div");
        this.groupElement.id = "SmartUIDebugger-groups";

        this.groupElement.style.position = "fixed";
        this.groupElement.style.top = "0";
        this.groupElement.style.right = "18vw";
        this.groupElement.style.zIndex = "900";
        this.groupElement.style.width = "15vw";
        this.groupElement.style.paddingTop = "3vh";
        this.groupElement.style.paddingLeft = "3vw";
        this.groupElement.style.pointerEvents = "all";

        this.groupElement.style.backgroundColor = "rgba(50,50,50,.5)";
        this.groupElement.style.border = "solid 1px white";

        this.groupElement.style.color = "#fff";
        this.groupElement.style.fontSize = "16px";

        canvasManager.rootNode.appendChild(this.groupElement);
    }

    private updateGroups() {
        while (this.groupElement.firstChild) {
            this.groupElement.removeChild(this.groupElement.firstChild);
        }

        smartUiManager.getAllGroups().forEach((group) => {

            if (group instanceof AutoSmartUIGroup && group.isVisible()) {
                const label = document.createElement("div");

                label.innerText = `${group.name} (${group.getLayerName()})`;

                label.style.color = group.isEnabled() ? "white" : "grey";

                this.groupElement.appendChild(label);
            }
        });
    }

    private populateFlagToggles() {
        const smartFlags = Object.keys(SmartUIFlag).filter((key) => isNaN(Number(key)));

        smartFlags.forEach((key, index) => {

            const flag = Number(SmartUIFlag[key as any]);

            const label = document.createElement("span");

            label.innerText = key;

            const checkbox = document.createElement("input");
            this.checkboxes.push(new SmartFlagCheckbox(label, checkbox));

            checkbox.type = "checkbox";

            checkbox.onchange = (e) => this.setFlag(flag, (e.target as any).checked);

            const br = document.createElement("br");

            this.flagElement.appendChild(label);
            this.flagElement.appendChild(checkbox);
            this.flagElement.appendChild(br);
        });
    }

    private updateCheckboxes() {
        const smartFlags = Object.keys(SmartUIFlag).filter((key) => isNaN(Number(key)));

        smartFlags.forEach((key, index) => {

            const flag = Number(SmartUIFlag[key as any]);

            this.checkboxes[index].label.style.color = smartUiFlags.has(flag) ? "red" : "white";
            this.checkboxes[index].checkbox.checked = smartUiFlags.has(flag);
        });
    }

    private setFlag(flag: SmartUIFlag, value: boolean) {
        smartUiFlags.set(flag, value);
    }
}

class SmartFlagCheckbox {
    constructor(public label: HTMLSpanElement, public checkbox: HTMLInputElement) { }
}
